export const getBirthTime = (time: string | null): string => {
  if (time === null) return ''
  const [hour, minute] = time.split(':')
  const hourString = `${hour}`.padStart(2, '0')
  const minuteString = `${minute}`.padStart(2, '0')
  return `${hourString}:${minuteString} ${+hour < 12 ? 'AM' : 'PM'}`
}
